import React from "react";
import { FormRowWrapper } from "./styled";

const FormRow: React.FC = ({ children }) => {
  return <FormRowWrapper>{children}</FormRowWrapper>;
};

export default FormRow;
